var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.51953,
    y: 3.48047,
    width: 36.96,
    height: 36.96,
    rx: 18.48,
    fill: "#FECDCA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.51953,
    y: 3.48047,
    width: 36.96,
    height: 36.96,
    rx: 18.48,
    stroke: "#FEF3F2",
    strokeWidth: 6.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3903 15.0312H16.6103C15.7598 15.0312 15.0703 15.7207 15.0703 16.5712V27.3512C15.0703 28.2018 15.7598 28.8912 16.6103 28.8912H27.3903C28.2408 28.8912 28.9303 28.2018 28.9303 27.3512V16.5712C28.9303 15.7207 28.2408 15.0312 27.3903 15.0312Z",
    stroke: "#D92D20",
    strokeWidth: 1.2859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6914 19.6504L24.3114 24.2704",
    stroke: "#D92D20",
    strokeWidth: 1.2859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3114 19.6504L19.6914 24.2704",
    stroke: "#D92D20",
    strokeWidth: 1.2859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.710896c41413f18a2358e4dc5fabc840.svg";
export { ForwardRef as ReactComponent };